import { createActions } from 'redux-actions';
import { v1 as uuid1 } from 'uuid';

const actions = createActions(
  {
    ADD: (description, key) => ({
      processId: key || uuid1(),
      description,
    }),
    REMOVE: (processId) => ({ processId }),
  },
  { prefix: 'CORE/LOADER' },
);

export const {
  add,
  remove,
} = actions;
